import React from 'react';
import './index.scss';
export const ShareButton = props => {
	return (
		<div
			className="common-share-button"
			onClick={() => {
				props.onClick();
			}}>
			<i className="iconfont">&#xe657;</i>
			<span>分享</span>
		</div>
	);
};
